import React from "react";
import "./Skills.scss";

const areas = [
  { number: "01", title: "Frontend engineering", description: "Accessible, responsive interfaces and maintainable product architecture.", tools: "React · TypeScript · JavaScript · HTML & CSS" },
  { number: "02", title: "Product delivery", description: "Taking ambitious ideas from early decisions to reliable production software.", tools: "Architecture · Testing · Collaboration · CI/CD" },
  { number: "03", title: "Full-stack perspective", description: "Working across application layers so the frontend fits the wider system.", tools: "Node.js · Java · PostgreSQL · APIs" },
];

export default function Skills() {
  return (
    <section id="skills" className="expertise-section" aria-labelledby="skills-heading">
      <div className="site-width">
        <div className="section-intro"><div><p className="eyebrow">EXPERTISE / 03</p><h2 id="skills-heading">Built with intent.<br /><em>Delivered with care.</em></h2></div><p>The right tools matter. So do good judgment, clear communication, and a product that works for the people using it.</p></div>
        <div className="expertise-grid">{areas.map((area) => <article className="expertise-card" key={area.number}><span className="expertise-number">{area.number}</span><h3>{area.title}</h3><p>{area.description}</p><span className="expertise-tools">{area.tools}</span></article>)}</div>
      </div>
    </section>
  );
}
